var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row gutter-sm q-mb-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c(
              "q-field",
              { attrs: { count: 256 } },
              [
                _c("q-input", {
                  ref: "title",
                  attrs: {
                    "float-label": _vm.$t("title"),
                    error: _vm.$v.title.$error,
                    disable: _vm.has_answers
                  },
                  on: { input: _vm.$v.title.$touch },
                  model: {
                    value: _vm.title,
                    callback: function($$v) {
                      _vm.title = $$v
                    },
                    expression: "title"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c(
              "p",
              {
                staticClass: "caption",
                class: _vm.$v.description.$error ? "text-negative" : ""
              },
              [
                _vm._v(
                  "\n\t\t\t\t" + _vm._s(_vm.$t("introduction")) + "\n\t\t\t"
                )
              ]
            ),
            _c("q-editor", {
              ref: "description",
              attrs: {
                error: _vm.$v.description.$error,
                disable: _vm.has_answers,
                toolbar: [
                  ["bold", "italic", "strike", "underline"],
                  ["left", "center", "right", "justify"],
                  ["link", "upload"],
                  [
                    {
                      label: null,
                      icon: "fas fa-font",
                      fixedLabel: true,
                      fixedIcon: true,
                      list: "no-icons",
                      options: ["p", "h1", "h2", "h3", "h4", "h5", "h6", "code"]
                    },
                    {
                      label: null,
                      icon: "fas fa-text-height",
                      fixedLabel: true,
                      fixedIcon: true,
                      list: "no-icons",
                      options: [
                        "size-1",
                        "size-2",
                        "size-3",
                        "size-4",
                        "size-5",
                        "size-6",
                        "size-7"
                      ]
                    },
                    "removeFormat"
                  ],
                  ["quote", "unordered", "ordered"]
                ],
                definitions: {
                  bold: { label: null, icon: "fas fa-bold" },
                  italic: { label: null, icon: "fas fa-italic" },
                  strike: { label: null, icon: "fas fa-strikethrough" },
                  underline: { label: null, icon: "fas fa-underline" },
                  left: { label: null, icon: "fas fa-align-left" },
                  center: { label: null, icon: "fas fa-align-center" },
                  right: { label: null, icon: "fas fa-align-right" },
                  justify: { label: null, icon: "fas fa-align-justify" },
                  link: { label: null, icon: "fas fa-link" },
                  removeFormat: { label: null, icon: "fas fa-eraser" },
                  quote: { label: null, icon: "fas fa-quote-right" },
                  unordered: { label: null, icon: "fas fa-list-ul" },
                  ordered: { label: null, icon: "fas fa-list-ol" }
                }
              },
              on: { input: _vm.$v.description.$touch },
              model: {
                value: _vm.description,
                callback: function($$v) {
                  _vm.description = $$v
                },
                expression: "description"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-select", {
              ref: "is_mandatory",
              attrs: {
                "float-label": _vm.$t("type"),
                options: _vm.mandatory_list,
                disable: _vm.has_answers
              },
              model: {
                value: _vm.is_mandatory,
                callback: function($$v) {
                  _vm.is_mandatory = $$v
                },
                expression: "is_mandatory"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6 row items-center" },
          [
            _c("q-checkbox", {
              staticClass: "q-mx-auto",
              attrs: { val: true, label: _vm.$t("randomize_answers") },
              model: {
                value: _vm.randomize_answers,
                callback: function($$v) {
                  _vm.randomize_answers = $$v
                },
                expression: "randomize_answers"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "col-xs-12 col-sm-12 q-mb-xl" }, [
        _c("div", { staticClass: "row gutter-sm flex" }, [
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-6" },
            [
              _c("p", { staticClass: "caption" }, [
                _vm._v(_vm._s(_vm.$t("image")))
              ]),
              _c("uploader", {
                attrs: {
                  content_type: "images",
                  multiple: false,
                  aspect_ratio: 52 / 29,
                  aspect_ratio_string: "52/29",
                  disable: _vm.has_answers
                },
                on: { fileUploaded: _vm.imageUploaded }
              }),
              _vm.image_url
                ? _c(
                    "p",
                    { staticClass: "q-mt-md file-url" },
                    [
                      _c("q-icon", {
                        attrs: { name: "fas fa-check", color: "positive" }
                      }),
                      _c(
                        "a",
                        { attrs: { href: _vm.image_url, target: "_blank" } },
                        [_vm._v(" " + _vm._s(_vm.$truncateLink(_vm.image_url)))]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
            _c(
              "p",
              { staticClass: "caption" },
              [
                _vm._v(
                  "\n\t\t\t\t\t\t" +
                    _vm._s(_vm.$t("alt_image")) +
                    "\n\t\t\t\t\t\t"
                ),
                _c(
                  "q-icon",
                  {
                    staticClass: "q-ml-sm q-pb-sm",
                    attrs: {
                      name: "far fa-question-circle",
                      size: "1.5rem",
                      color: "grey"
                    }
                  },
                  [
                    _c(
                      "q-tooltip",
                      {
                        staticClass: "custom-tooltip",
                        attrs: { anchor: "top left", self: "bottom right" }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t" +
                            _vm._s(_vm.$t("alt_image_information_helper")) +
                            "\n\t\t\t\t\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "flex justify-between" },
              [
                _vm._l(_vm.languages, function(lang) {
                  return [
                    lang.code === "pt-br"
                      ? _c(
                          "q-field",
                          { key: lang.id, attrs: { count: 170 } },
                          [
                            _c("q-input", {
                              ref: "language_br",
                              refInFor: true,
                              attrs: {
                                "float-label": _vm.$t("" + lang.name),
                                error: _vm.$v.language_br.$error,
                                disable: _vm.has_answers
                              },
                              on: { input: _vm.$v.language_br.$touch },
                              model: {
                                value: _vm.language_br,
                                callback: function($$v) {
                                  _vm.language_br = $$v
                                },
                                expression: "language_br"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    lang.code === "en-us"
                      ? _c(
                          "q-field",
                          { key: lang.id, attrs: { count: 170 } },
                          [
                            _c("q-input", {
                              ref: "language_us",
                              refInFor: true,
                              attrs: {
                                "float-label": _vm.$t("" + lang.name),
                                error: _vm.$v.language_us.$error,
                                disable: _vm.has_answers
                              },
                              on: { input: _vm.$v.language_us.$touch },
                              model: {
                                value: _vm.language_us,
                                callback: function($$v) {
                                  _vm.language_us = $$v
                                },
                                expression: "language_us"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    lang.code === "es-es"
                      ? _c(
                          "q-field",
                          { key: lang.id, attrs: { count: 170 } },
                          [
                            _c("q-input", {
                              ref: "language_es",
                              refInFor: true,
                              attrs: {
                                "float-label": _vm.$t("" + lang.name),
                                error: _vm.$v.language_es.$error,
                                disable: _vm.has_answers
                              },
                              on: { input: _vm.$v.language_es.$touch },
                              model: {
                                value: _vm.language_es,
                                callback: function($$v) {
                                  _vm.language_es = $$v
                                },
                                expression: "language_es"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    lang.code === "fr-fr"
                      ? _c(
                          "q-field",
                          { key: lang.id, attrs: { count: 170 } },
                          [
                            _c("q-input", {
                              ref: "language_fr",
                              refInFor: true,
                              attrs: {
                                "float-label": _vm.$t("" + lang.name),
                                error: _vm.$v.language_fr.$error,
                                disable: _vm.has_answers
                              },
                              on: { input: _vm.$v.language_fr.$touch },
                              model: {
                                value: _vm.language_fr,
                                callback: function($$v) {
                                  _vm.language_fr = $$v
                                },
                                expression: "language_fr"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                })
              ],
              2
            )
          ])
        ])
      ]),
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1",
          attrs: { color: "secondary" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "permissions",
              icon: "fas fa-clipboard-check",
              label: _vm.$t("permissions")
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { staticClass: "q-px-lg q-pb-xl", attrs: { name: "permissions" } },
            [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("p", { staticClass: "caption" }, [
                      _vm._v(_vm._s(_vm.$t("areas")))
                    ]),
                    _c("q-checkbox", {
                      staticClass: "q-mb-sm",
                      attrs: {
                        val: true,
                        label: _vm.$t("select_all_areas"),
                        disable: _vm.has_answers
                      },
                      on: {
                        input: function($event) {
                          return _vm.checkAllAreas()
                        }
                      },
                      model: {
                        value: _vm.all_areas,
                        callback: function($$v) {
                          _vm.all_areas = $$v
                        },
                        expression: "all_areas"
                      }
                    }),
                    _c("q-select", {
                      ref: "areas",
                      attrs: {
                        filter: "",
                        "autofocus-filter": "",
                        options: _vm.areas_list,
                        error: _vm.$v.areas.$error,
                        multiple: "",
                        chips: "",
                        disable: _vm.has_answers
                      },
                      on: { input: _vm.$v.areas.$touch },
                      model: {
                        value: _vm.areas,
                        callback: function($$v) {
                          _vm.areas = $$v
                        },
                        expression: "areas"
                      }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                  _c("p", { staticClass: "caption" }, [
                    _vm._v(_vm._s(_vm.$t("profiles")))
                  ]),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c("q-checkbox", {
                            attrs: {
                              val: true,
                              label: _vm.$t("all"),
                              disable: _vm.has_answers
                            },
                            on: {
                              input: function($event) {
                                return _vm.checkAll()
                              }
                            },
                            model: {
                              value: _vm.all_profiles,
                              callback: function($$v) {
                                _vm.all_profiles = $$v
                              },
                              expression: "all_profiles"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._l(_vm.profiles_list, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "col-xs-12 col-sm-4",
                            class: _vm.getErrorClass(_vm.$v.profiles.$error)
                          },
                          [
                            _c("q-checkbox", {
                              ref: "profiles",
                              refInFor: true,
                              attrs: {
                                "keep-color": "",
                                val: item.value,
                                label: item.label,
                                color: _vm.getErrorColor(
                                  _vm.$v.profiles.$error
                                ),
                                disable: _vm.has_answers
                              },
                              on: { input: _vm.$v.profiles.$touch },
                              model: {
                                value: _vm.profiles,
                                callback: function($$v) {
                                  _vm.profiles = $$v
                                },
                                expression: "profiles"
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c("q-select", {
                            ref: "user_groups",
                            attrs: {
                              options: _vm.user_groups_list,
                              "float-label": _vm.$t("groups"),
                              error: _vm.$v.user_groups.$error,
                              multiple: "",
                              chips: "",
                              disable: _vm.has_answers
                            },
                            on: { input: _vm.$v.user_groups.$touch },
                            model: {
                              value: _vm.user_groups,
                              callback: function($$v) {
                                _vm.user_groups = $$v
                              },
                              expression: "user_groups"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                ])
              ])
            ]
          )
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "fas fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_drills" })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("save"),
                icon: "far fa-save"
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }